import FlowConfigBase from '#client/config/FlowConfigBase';
import PAGES, { PAGE_KEYS } from '#client/config/flowPageConfig';
import * as ROUTES from '#client/constants/routes';

export default FlowConfigBase.createEntry({
  id: 'corp',
  pageKeys: [
    PAGE_KEYS.BUSINESS_INFO,
    PAGE_KEYS.CONTACT_INFO,
    PAGE_KEYS.BUSINESS_EXPERIENCE,
    PAGE_KEYS.BUSINESS_STAGE,
    PAGE_KEYS.INDUSTRY,
    PAGE_KEYS.REGISTERED_AGENT,
    PAGE_KEYS.PACKAGE_SELECTION,
    PAGE_KEYS.WFC,
    PAGE_KEYS.EIN,
    PAGE_KEYS.CORPORATE_BYLAWS,
    PAGE_KEYS.MONEY_PRO,
    PAGE_KEYS.RUSH_FILING,
    PAGE_KEYS.CHECKOUT
  ],
  pageConfigs: {
    [PAGES.BUSINESS_INFO.pageComponent]: {
      pageComponentProps: {
        formationCountyStates: new Set(['GA', 'PA'])
      }
    },
    [PAGES.WFC.pageComponent]: {
      pageComponentProps: {
        couponCode: '199_off_first_year'
      }
    }
  },
  entityType: 'corp',
  hasFormation: true,
  isPrimary: true,
  postOrderAutoLogin: true,
  postOrderRedirect: ROUTES.SHOP_CORP_ADDONS,
  priceListUuids: {
    development: '2a0e3b95-84db-4fd5-ab41-685a79151393',
    production: '5aa483da-649d-4c16-9ee2-c481ff296f73'
  }
});
